import { Key, KeyCode } from "./commonTypes";
import { isNotNilOrEmpty } from "./utils";

export function tryResolveKeyboardKey(event: KeyboardEventLike): Key | null {
	if (isNotNilOrEmpty(event.key)) {
		return event.key as Key;
	}

	return tryParseKeyCode(event.keyCode);
}

export function tryParseKeyCode(keyCode: KeyCode): Key | null {
	switch (keyCode) {
		case KeyCode.Enter:
			return Key.Enter;
		case KeyCode.Left:
			return Key.ArrowLeft;
		case KeyCode.Right:
			return Key.ArrowRight;
		case KeyCode.Up:
			return Key.ArrowUp;
		case KeyCode.Down:
			return Key.ArrowDown;
		case KeyCode.Escape:
			return Key.Escape;
		case KeyCode.Delete:
			return Key.Delete;
		case KeyCode.PageUp:
			return Key.PageUp;
		case KeyCode.PageDown:
			return Key.PageDown;
		case KeyCode.Home:
			return Key.Home;
		case KeyCode.End:
			return Key.End;
		case KeyCode.Tab:
			return Key.Tab;
		case KeyCode.Backspace:
			return Key.Backspace;
		default:
			return ((_key: never): Key | null => null)(keyCode);
	}
}

export interface KeyboardEventLike {
	keyCode: KeyCode;
	key?: string;
}
